import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useI18n } from "../context/I18nContext";

export const ExportPdfButton = ({ className = "" }) => {
  const { t, lang } = useI18n();
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/entries/export/pdf?lang=${lang}`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `echo-journal-${new Date().toISOString().slice(0, 10)}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(t("pdf_done"));
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button data-testid="export-pdf-btn" onClick={run} disabled={busy}
      className={`px-5 py-3 rounded-full border border-[#E5C158]/40 text-[#E5C158] hover:bg-[#E5C158]/10 inline-flex items-center gap-2 transition-colors disabled:opacity-60 ${className}`}>
      {busy ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />} {t("pdf_export")}
    </button>
  );
};
